<svg width="0" height="0" style="position: absolute;">
  <defs>
    <clipPath id="shape-mask" clipPathUnits="objectBoundingBox">
      <path d="M0.077,0 H0.923 C0.965,0 1,0.035 1,0.077 V0.78 C1,0.822 0.965,0.857 0.923,0.857 H0.78 C0.738,0.857 0.703,0.892 0.703,0.934 V0.923 C0.703,0.965 0.668,1 0.626,1 H0.077 C0.035,1 0,0.965 0,0.923 V0.077 C0,0.035 0.035,0 0.077,0 Z" />
    </clipPath>
  </defs>
</svg>

<main class="flex min-h-screen items-center justify-between bg-gradient-to-r from-lBlack to-lBlue700 px-6 sm:px-4">
  <section class="first-access flex w-full flex-col items-center justify-center lg:max-w-[40%]">
    <div class="first-access__column w-full animate-fadeIn">
      <img class="first-access__logo mx-auto" src="assets/images/unico-logo.svg" alt="uni:co." width="130" />

      @switch (step) {
        @case ('validating') {
          <output class="block text-center">
            <h1 class="first-access__title">Validando seu link</h1>
            <p class="first-access__subtitle">Aguarde um instante enquanto verificamos seu acesso.</p>
            <div class="mt-8 flex justify-center">
              <l-spinner [size]="spinnerSize.MEDIUM" />
            </div>
          </output>
        }

        @case ('form') {
          <div class="text-center">
            <h1 class="first-access__title">Crie sua senha</h1>
            <p class="first-access__subtitle">
              Este é o seu primeiro acesso. Crie uma senha para entrar e explorar um mundo de possibilidades.
            </p>
          </div>

          <form class="first-access__form" [formGroup]="form" (submit)="submit()" autocomplete="off" novalidate>
            <div class="first-access__field">
              <label class="first-access__label" for="password">Senha</label>
              <div class="form-input first-access__input relative flex items-center" [class.has-error]="passwordHasError">
                <l-icon class="form-input--icon">lock</l-icon>
                <input
                  type="password"
                  [type]="hidePassword ? 'password' : 'text'"
                  id="password"
                  placeholder="Digite sua senha"
                  formControlName="password"
                  autocomplete="new-password"
                />
                <button
                  type="button"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-lSecondary transition-colors hover:text-lWhite disabled:pointer-events-none"
                  [disabled]="isSubmitting"
                  [attr.aria-label]="hidePassword ? 'Mostrar senha' : 'Ocultar senha'"
                  (click)="hidePassword = !hidePassword"
                >
                  <l-icon class="mt-2 text-base font-normal">{{ hidePassword ? 'visibility_off' : 'visibility' }}</l-icon>
                </button>
              </div>
            </div>

            <div class="first-access__field">
              <label class="first-access__label" for="confirm-password">Confirmar senha</label>
              <div class="form-input first-access__input relative flex items-center" [class.has-error]="confirmPasswordHasError">
                <l-icon class="form-input--icon">lock</l-icon>
                <input
                  type="password"
                  [type]="hideConfirmPassword ? 'password' : 'text'"
                  id="confirm-password"
                  placeholder="Repita sua senha"
                  formControlName="confirmPassword"
                  autocomplete="new-password"
                />
                <button
                  type="button"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-lSecondary transition-colors hover:text-lWhite disabled:pointer-events-none"
                  [disabled]="isSubmitting"
                  [attr.aria-label]="hideConfirmPassword ? 'Mostrar confirmação da senha' : 'Ocultar confirmação da senha'"
                  (click)="hideConfirmPassword = !hideConfirmPassword"
                >
                  <l-icon class="mt-2 text-base font-normal">{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</l-icon>
                </button>
              </div>

              <l-password-feedback
                [password]="form.controls.password.value"
                [confirmPassword]="form.controls.confirmPassword.value"
              />
            </div>

            <div class="first-access__submit">
              @if (submitError) {
                <div class="first-access__alert" role="alert">
                  <l-icon class="first-access__alert-icon">error</l-icon>
                  <div>
                    <p class="first-access__alert-title">Não foi possível criar sua senha</p>
                    <p class="first-access__alert-text">{{ submitError }}</p>
                  </div>
                </div>
              }

              <button
                lButton
                type="submit"
                [disabled]="isSubmitting"
                [bType]="buttonTypes.PRIMARY"
                [bRadius]="buttonRadius.LARGE"
              >
                @if (isSubmitting) {
                  <l-spinner [size]="spinnerSize.SMALL" [color]="spinnerColors.WHITE" />
                  <span>Criando senha…</span>
                } @else {
                  <span>{{ submitError ? 'Tentar novamente' : 'Criar senha' }}</span>
                }
              </button>
            </div>
          </form>
        }

        @case ('success') {
          <div class="text-center">
            <h1 class="first-access__title">Senha criada com sucesso!</h1>
            <p class="first-access__subtitle">Tudo pronto! Agora é só acessar sua conta e explorar um mundo de possibilidades.</p>
          </div>

          <div class="mt-8 w-full">
            <button lButton type="button" [bType]="buttonTypes.PRIMARY" [bRadius]="buttonRadius.LARGE" (click)="goToLogin()">
              Acessar tela de login
            </button>
          </div>
        }

        @case ('expired') {
          <div class="text-center">
            <div class="first-access__badge first-access__badge--warning">
              <l-icon>schedule</l-icon>
            </div>
            <h1 class="first-access__title">Este link expirou</h1>
            <p class="first-access__subtitle">
              Por segurança, o link de primeiro acesso tem validade limitada. Solicite um novo link ao administrador da sua conta para criar sua senha.
            </p>
          </div>

          <div class="first-access__actions">
            <button lButton type="button" [bType]="buttonTypes.PRIMARY" [bRadius]="buttonRadius.LARGE" (click)="goToLogin()">
              Acessar tela de login
            </button>
          </div>
        }

        @case ('invalid') {
          <div class="text-center">
            <div class="first-access__badge first-access__badge--danger">
              <l-icon>link_off</l-icon>
            </div>
            <h1 class="first-access__title">Link inválido</h1>
            <p class="first-access__subtitle">{{ invalidDescription }}</p>
          </div>

          <div class="first-access__actions">
            <button lButton type="button" [bType]="buttonTypes.PRIMARY" [bRadius]="buttonRadius.LARGE" (click)="goToLogin()">
              Acessar tela de login
            </button>
            <p class="first-access__secondary">
              Não lembra sua senha?
              <button type="button" class="first-access__link" (click)="goToForgotPassword()">Esqueci minha senha</button>
            </p>
          </div>
        }

        @case ('unavailable') {
          <div class="text-center">
            <div class="first-access__badge first-access__badge--danger">
              <l-icon>wifi_off</l-icon>
            </div>
            <h1 class="first-access__title">Não foi possível validar seu link</h1>
            <p class="first-access__subtitle">Verifique sua conexão e tente novamente.</p>
          </div>

          <div class="first-access__actions">
            <button lButton type="button" [bType]="buttonTypes.PRIMARY" [bRadius]="buttonRadius.LARGE" (click)="validateLink()">
              Tentar novamente
            </button>
            <p class="first-access__secondary">
              Já tem uma senha?
              <button type="button" class="first-access__link" (click)="goToLogin()">Acessar tela de login</button>
            </p>
          </div>
        }
      }
    </div>
  </section>

  <aside class="hidden h-screen flex-1 items-center justify-center lg:flex">
    <div class="relative h-[95%] w-[95%]">
      <div class="shape-card h-full w-full"></div>

      <l-animated-banner class="pointer-events-none absolute inset-0 z-10" />

      <div class="gradient-border absolute bottom-[20%] left-[5%] z-20 lg:bottom-[25%] lg:left-[10%] xl:bottom-[30%]">
        <span class="text-sm font-semibold text-lWhite lg:text-base xl:text-lg 2xl:text-xl">Educação Corporativa</span>
      </div>
      <div class="gradient-border absolute bottom-[10%] left-0 z-20 lg:bottom-[15%] xl:bottom-[20%]">
        <span class="text-sm font-semibold text-lWhite lg:text-base xl:text-lg 2xl:text-xl">Treinamentos e workshops</span>
      </div>

      <img src="assets/images/unico-logo.svg" alt="uni:co." class="absolute bottom-[5%] right-[7%] z-10 w-[15%] min-w-28" />
    </div>
  </aside>
</main>
